import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
const EditDesignations = () => {
  // const { id } = useParams();
  useEffect(() => {
    const scriptUrls = [
      'assets/js/jquery.min.js',
      'assets/js/bootstrap.bundle.min.js',
      'assets/js/moment.min.js',
      'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
      'assets/vendor/overlay-scroll/custom-scrollbar.js',
      'assets/vendor/daterange/daterange.js',
      'assets/vendor/daterange/custom-daterange.js',
      'assets/vendor/jquery-ui/jquery-ui.min.js',
      'assets/vendor/jquery-ui/custom.js',
      //'assets/vendor/apex/apexcharts.min.js',
      //'assets/vendor/apex/custom/home/patients.js',
      //'assets/vendor/apex/custom/home/department-income.js',
      //'assets/vendor/apex/custom/home/income.js',
      //'assets/vendor/apex/custom/home/appointments-overview.js',
      //'assets/vendor/apex/custom/home/sparklines.js',
      'assets/vendor/datatables/dataTables.min.js',
      'assets/vendor/datatables/dataTables.bootstrap.min.js',
      'assets/vendor/datatables/custom/custom-datatables.js',
      'assets/js/custom.js'
    ];

    let isCancelled = false;

    // Load scripts sequentially
    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
      // Optionally remove scripts if needed
    };
  }, []);
  const navigate = useNavigate(); // For navigation
  const location = useLocation();
  const uata = location.state?.uata;
  const [designationTbl, setDesignationTbl] = useState([]);
  const [depName, setDepName] = useState('');
  const [designation, setDesignation] = useState('');
  useEffect(() => {
    const REST_API_BASE_URL = `http://localhost:8080/api/listBooks/${uata}`;
    const designationById = () => axios.get(REST_API_BASE_URL);
    designationById().then((response) => {
      const designationData = response.data;
      setDesignationTbl(designationData);
      setDepName(designationData.depName);
      setDesignation(designationData.designation);

    }).catch(error => {
      window.alert(error + " " + uata);

    })
  }, [])
  const handleUpdate = (e) => {
    // Prevent default form submission
    e.preventDefault();

    // Show confirmation dialog
    const confirmUpdate = window.confirm(
      `Are you sure you want to update item with ID: ${uata}?`
    );

    if (confirmUpdate) {
      // If confirmed, perform the update action 
      const formData = new FormData();
      formData.append("jsonData", JSON.stringify({
        "dep_name": depName,
        "designation": designation,
      }));
     
      

      console.log();
      const REST_API_BASE_URL = `http://localhost:8080/api/insBookById/${uata}`;
      const updateWithIds = (formData) => axios.put(REST_API_BASE_URL, formData);
      updateWithIds(formData)
        .then((response) => {
          console.log(response.data);
          window.alert(`Successfully updation done with ${uata}`);

          // After deletion, redirect to another page (e.g., home or item list)
          navigate("/booklist"); // Navigates back to the homepage or another route
        })
        .catch((error) => {
          window.alert("Error occurred while updating the item.");
          console.error(error);
        });
    } else {
      // If cancelled, do nothing (or show a cancellation message)
      window.alert("Updation cancelled");
      navigate("/add-designations");
    }
  };
  const handleCancle = (e) => {
    e.preventDefault();
    
    // Perform update logic if needed
    console.log("Updating designation...");
  
    // Navigate to the designation page after update
    navigate("/add-designations");
    window.location.reload();
  };

  return (
    <div>
      {/* App hero header starts */}
      <div className="app-hero-header d-flex align-items-center">
        {/* Breadcrumb starts */}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="index-2.html">
              <i className="ri-home-3-line" />
            </a>
          </li>
          <li className="breadcrumb-item">Designtions</li>
          <li className="breadcrumb-item text-primary" aria-current="page">
            Update Designtions
          </li>
        </ol>
        {/* Breadcrumb ends */}
        {/* Sales stats starts */}
        <div className="ms-auto d-lg-flex d-none flex-row">
          <div className="input-group">
            <span className="input-group-text bg-primary-lighten">
              <i className="ri-calendar-2-line text-primary" />
            </span>
            <input type="text" id="abc" className="form-control custom-daterange" />
          </div>
        </div>
        {/* Sales stats ends */}
      </div>
      {/* App Hero header ends */}
      {/* App body starts */}
      <div className="app-body">
        {/* Row starts */}
        <div className="row gx-4">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title">Update Designtions</h5>
              </div>
              <div className="card-body">
                {/* Row starts */}
                <div className="row gx-4 align-items-end">
                  {/* Department Dropdown */}
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a1">Department</label>
                      <select
                        className="form-select"
                        id="a4"
                        onChange={(e) => setDepName(e.target.value)}
                        defaultValue={designationTbl.depName}
                      >
                        <option value={0}>Select</option>
                        <option value={1}>Surgeon</option>
                        <option value={2}>Gynecologist</option>
                        <option value={3}>Psychiatrists</option>
                        <option value={4}>Urologist</option>
                        <option value={5}>Paediatrician</option>
                      </select>
                    </div>
                  </div>

                  {/* Designation Input */}
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a2">Designation</label>
                      <input
                        type="text"
                        className="form-control"
                        id="a2"
                        placeholder="Designation"
                        onChange={(e) => setDesignation(e.target.value)}
                        defaultValue={designationTbl.designation}
                      />
                    </div>
                  </div>
                  <div className="col-sm-4 d-flex gap-3 mb-3 justify-content-end">
                    <button className="btn btn-outline-secondary w-70" onClick={handleCancle}  >
                      Cancel
                    </button>
                    <button className="btn btn-primary w-70" onClick={handleUpdate}>
                      Update Designation
                    </button>
                  </div>

                  {/* Action Buttons */}
                 
                </div>

                {/* Row ends */}
              </div>
            </div>
          </div>

        </div>

        {/* Row ends */}
      </div>
      {/* App body ends */}
    </div>


  );
};

export default EditDesignations;

